import { staticFileMap } from '/utils/static-file';
import { productCodeMap } from '@/utils/document/product-code-map';

const docConfig = { name: '产品文档', link: productCodeMap.VTM };
const path = '/img/products/digital-human';

export const BANNER_DATA = {
  title: '虚拟人',
  backgroundImg: `${path}/banner.webp`,
  description:
    '基于自研的虚拟人全链路AI技术，提供集虚拟形象建模、绑定驱动、实时渲染、内容运营于一体的虚拟人解决方案。助力客户打造虚拟形象对外传播，赋能营销新玩法。为直播电商、虚拟拍摄、智能文娱等行业带来新机遇',
  buttonText: '立即咨询',
  buttonLink: '',
  docText: '产品文档',
  mobileExtraButton: { ...docConfig },
  backgroundImgMobile: `${path}/bannerMobile.webp`,
  links: [
    // { name: 'Demo体验', link: '' },
    { ...docConfig },
    // { name: '管理控制台', link: '' },
  ],
};

export const CARDS_EFFECT = [
  {
    title: '虚拟互动直播',
    content:
      '基于端云结合的低延迟实时渲染技术，以虚拟人和虚拟空间为载体，为各大主播、MCN机构提供沉浸式直播服务，支持多人互动、开放式剧情等全新玩法',
    picUrl: `${path}/3D-icon1.webp`,
  },
  {
    title: 'AI虚拟主播',
    content:
      '简单输入文字，即可快速生成具备精确口型和丰富表情动作的虚拟主播播报视频；可广泛应用于新闻播报、讲师培训、营销宣传等视频生产场景',
    picUrl: `${path}/3D-icon2.webp`,
  },
  {
    title: '虚拟偶像',
    content:
      '以超写实渲染、多模态驱动、歌唱合成等技术为基础，建立虚拟人才艺表演、实时直播互动和短视频制作能力，使虚拟偶像应用在品牌代言、直播打赏等商业模式中/静态等多种高度贴合面部的装扮及特效',
    picUrl: `${path}/3D-icon3.webp`,
  },
  {
    title: '虚拟资产',
    content:
      '自主研发出一套通用的虚拟人头发、服装生成方案，并储备了多种类型的3D模型；让客户更快速、低成本定制虚拟人相关数字资产，满足多元化需求',
    picUrl: `${path}/3D-icon4.webp`,
  },
];
export const ADVANTAGES_EFFECT = [
  {
    title: '全链路解决方案',
    content:
      '提供虚拟资产、系统软件、渲染引擎、动作捕捉、虚拟拍摄和运营在内的一站式全流程服务',
    picUrl: `${path}/icon1.webp`,
  },
  {
    title: '高品质可规模化',
    content:
      '多种成本方案，构建虚拟人标准生产流程保障高品质输出，缩短项目交付周期，实现快速规模化',
    picUrl: `${path}/icon2.webp`,
  },
  {
    title: '丰富的互动玩法',
    content:
      '支持云端渲染和远程多人互动，结合新颖的特效玩法与快手生态优势，为观众带来全新的直播体验',
    picUrl: `${path}/icon3.webp`,
  },
  {
    title: '多行业应用场景',
    content:
      '具备高效的短视频制作和成熟的直播服务能力，在电商、娱乐、政企等多个行业有丰富的落地经验',
    picUrl: `${path}/icon4.webp`,
  },
];

export const DEMO_LIST = [
  {
    demoTitle: '快手虚拟演播助手',
    videoUrl: staticFileMap['digital-human-assistant'],
    posterUrl: `${path}/assistant.webp`,
    placeholder: `${path}/assistant.webp`,
    demoDesc: [
      {
        title: '虚拟人驱动与交互',
        subTitle: '支持虚拟人制作、驱动、渲染',
      },
      {
        title: '端云结合的虚拟互动',
        subTitle: '构建3D场景、打造虚拟空间互动',
      },
      {
        title: '虚实融合的趣味创作',
        subTitle: '包含数万款流行特效、道具玩法',
      },
    ],
  },
  {
    demoTitle: 'AI虚拟主播',
    videoUrl: staticFileMap['digital-human-vtuber'],
    posterUrl: `${path}/vtuber.webp`,
    placeholder: `${path}/vtuber.webp`,
    demoDesc: [
      {
        title: '逼真的虚拟形象',
        subTitle: '2D真人虚拟形象可达到肉眼难辨真假',
      },
      {
        title: '自然的音色表情',
        subTitle: '超真实音色，匹配生动自然的面部表情',
      },
      {
        title: '超低启用配置成本',
        subTitle: '仅需分钟级配置即可使用',
      },
    ],
  },
  {
    demoTitle: '虚拟偶像',
    videoUrl: staticFileMap['digital-human-idol'],
    posterUrl: `${path}/idol.webp`,
    placeholder: `${path}/idol.webp`,
    demoDesc: [
      {
        title: '超写实渲染',
        subTitle: '超真实风格，影视级制作',
      },
      {
        title: 'AI歌舞生成',
        subTitle: '多种曲风舞姿自动生成，带来美妙视听体验',
      },
      {
        title: '多种商业模式',
        subTitle: '结合快手生态，支持广告宣传、品牌代言等合作模式',
      },
    ],
  },
];

export const SCENARIO = [
  {
    title: '电商卖货',
    content:
      '面向品牌商家和直播带货MCN，虚拟人开播实现更长直播时间、更多观看人数、更快涨粉速度，引流增收',
    picUrl: `${path}/scenario1.webp`,
  },
  {
    title: '政务传媒',
    content:
      '针对新闻播报、游戏讲解、电视导播等媒体场景需求，打造差异化虚拟主播IP，扩大影响力',
    picUrl: `${path}/scenario2.webp`,
  },
  {
    title: '虚拟客服',
    content:
      '针对政企平台，AI虚拟主播化身智能客服，植入大屏一体机或Web页面，为用户提供问答服务',
    picUrl: `${path}/scenario3.webp`,
  },
  {
    title: '直播互动',
    content:
      '面向各垂类主播，提供多种炫酷特效、礼物、道具及联机互动玩法，增加直播趣味性',
    picUrl: `${path}/scenario4.webp`,
  },
];

export const BRAND = {
  title: '客户案例',
  items: ['蒙牛', '快手', 'AcFun', '磁力引擎'],
};
